import DocumentationIcon from "./DocumentationIcon";

export default DocumentationIcon;